import Vue from 'vue'
import Vuex from 'vuex'
import { dbFB, storage, FBFUNCTIONS } from '@/plugins/firebase'
import axios from 'axios'

import STAFF from '@/data/staff.json'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    version: '1.0.1',
    works: [],
    curriculum: null,
    staff: STAFF,
  },
  getters: {
    curriculumStored: state => {
      return state.curriculum && state.curriculum.is_stored
    },

    curriculumLink: state => {
      return state.curriculum && state.curriculum.is_token ? state.curriculum.linkAccess : null
    },
  },
  mutations: {
    setMutWorks: (state, payload) => {
      state.works = payload
    },

    setCurriculum: (state, payload) => {
      state.curriculum = payload
    },
  },
  actions: {
    reCaptchaValidate: (payload) => {
      const saveForm = FBFUNCTIONS.httpsCallable('reCaptchaValidate')
      saveForm(payload)
        .then(response => {
          console.info('Validado')
          return true
          // console.log(response.data)
          // commit('contactFormSended', response.data)
        })
        .catch(error => {
          console.error(error)
          return false
          // commit('contactFormSended', error)
        })
    },

    getWorks: ({ commit }) => {
      dbFB.ref('ofertasempleo').once('value').then((snapshot) => {
        const datos = snapshot.val()
        commit('setMutWorks', datos)
      })
    },

    sendCurriculum: ({ dispatch, commit }, payload) => {
      // console.log(payload)
      if (!payload || !payload.isHuman) {
        console.error('Ha ocurrido un error')
        return
      }
      const fileName = `${new Date().getTime()}_${payload.email}_${payload.file.name}`
      const ruta = `curriculums/${payload.referencia}/${fileName}`
      const nameEncoded = encodeURIComponent(ruta)
      const urlBase = `https://firebasestorage.googleapis.com/v0/b/rosmar-web.appspot.com/o/${nameEncoded}`
      const dataCurriculum = Object.assign({}, payload)
      dataCurriculum.urlBase = urlBase
      const guardar = storage.ref().child(ruta)
      guardar.put(payload.file)
        .then(snapshot => {
          // console.log(snapshot)
          dataCurriculum.is_stored = true
          commit('setCurriculum', dataCurriculum)
          dispatch('getUrlCurriculum', dataCurriculum)
        })
        .catch(error => {
          console.error(error)
        })
    },

    getUrlCurriculum: ({ dispatch, commit }, payload) => {
      // console.log(payload)
      const url = payload.urlBase
      if (!url.length) {
        console.error('Error: Falta la urlBase')
        return
      }
      axios.get(url)
        .then(response => {
          // console.log(JSON.stringify(response.data))
          const token = `${url}?alt=media&token=${response.data.downloadTokens}`
          const dataCurriculum = Object.assign({}, payload)
          dataCurriculum.linkAccess = token
          dataCurriculum.file = response.data
          dataCurriculum.is_token = true
          dataCurriculum.isProduction = true
          commit('setCurriculum', dataCurriculum)
          // console.log(token)
          dispatch('saveCurriculum', dataCurriculum)
        })
        .catch(error => {
          console.error(error)
        })
    },

    saveCurriculum: ({ commit }, payload) => {
      const saveForm = FBFUNCTIONS.httpsCallable('newCurriculum')
      saveForm(payload)
        .then(response => {
          console.info('Terminado')
          // console.log(response.data)
          // commit('contactFormSended', response.data)
        })
        .catch(error => {
          console.error(error)
          // commit('contactFormSended', error)
        })
    },
  },
  modules: {
  },
})
